import React, {
	Dispatch,
	SetStateAction,
	useContext,
	useEffect,
	useState,
} from 'react';
import { Block } from '../../../../../../types/shared/blocks';
import { Stack } from '@mui/material';
import FeetInchesInput from '../FeetInchesInputV2';
import EdgeLabel from '../../../../../../enums/edgeLabel';
import updateChildBlocks from '../../utils/updateChildBlocks';
import { DeckContext } from '../../context/DeckContext';

const BumpoutPopper: React.FC<{
	block: Block;
	setExternalBlockData: Dispatch<SetStateAction<Block>>;
}> = ({ block, setExternalBlockData }) => {
	const { state, dispatch } = useContext(DeckContext);

	const [blockData, setBlockData] = useState(block);

	useEffect(() => {
		setExternalBlockData(blockData);
	}, [blockData]);

	const handleWidthChange = (inches) => {
		const updatedData = {
			...blockData,
			dimensions: {
				width: inches,
				depth: blockData.dimensions.depth,
				height: blockData.dimensions.height,
			},
			displayDimensions: {
				width: inches,
				height: blockData.dimensions.depth,
			},
			edges: blockData.edges.map((edge) => {
				if (edge.label == EdgeLabel.TOP || edge.label == EdgeLabel.BOTTOM) {
					return {
						...edge,
						length: inches,
					};
				}
				return edge;
			}),
		};
		setBlockData(updatedData);

		dispatch({
			type: 'UPDATE_BLOCK',
			payload: updatedData,
		});

		// Update child blocks
		updateChildBlocks({
			blocks: state.blocks,
			oldBlock: block,
			updatedBlock: updatedData,
			dispatch,
		});

		if (onAutoSave) {
			onAutoSave();
		}
	};

	const handleDepthChange = (inches) => {
		const updatedData = {
			...blockData,
			dimensions: {
				width: blockData.dimensions.width,
				depth: inches,
				height: blockData.dimensions.height,
			},
			displayDimensions: {
				width: blockData.dimensions.width,

				height: inches,
			},
			edges: blockData.edges.map((edge) => {
				if (edge.label == EdgeLabel.LEFT || edge.label == EdgeLabel.RIGHT) {
					return {
						...edge,
						length: inches,
					};
				}

				return edge;
			}),
		};
		setBlockData(updatedData);

		dispatch({
			type: 'UPDATE_BLOCK',
			payload: updatedData,
		});

		// Update child blocks
		updateChildBlocks({
			blocks: state.blocks,
			oldBlock: block,
			updatedBlock: updatedData,
			dispatch,
		});

		if (onAutoSave) {
			onAutoSave();
		}
	};

	return (
		<Stack spacing={1.25}>
			<FeetInchesInput
				valueInches={blockData.dimensions.depth}
				labelInches="Depth"
				onChange={handleDepthChange}
			/>

			<FeetInchesInput
				valueInches={blockData.dimensions.width}
				labelInches="Width"
				onChange={handleWidthChange}
			/>
		</Stack>
	);
};

export default BumpoutPopper;
